import { useMemo } from "react";
import { useAuth } from "../context/AuthContexts"; // ✅ adjust to your actual path

type GateMode = "any" | "all";

export function useAccess() {
  const {
    user,
    loading,
    hasPermission,
    hasAnyPermission,
    hasRole,
    hasAnyRole,
  } = useAuth();

  const perms = useMemo(() => user?.permissions || [], [user]);
  const roles = useMemo(() => user?.roles || [], [user]);

  const adminPerms = useMemo(() => {
    return perms.filter((p) => String(p).toLowerCase().startsWith("admin."));
  }, [perms]);

  const all = (list: string[]) => list.every((p) => hasPermission(p));
  const any = (list: string[]) => hasAnyPermission(list);

  const allow = (permOrList: string | string[], mode: GateMode = "any") => {
    if (Array.isArray(permOrList))
      return mode === "all" ? all(permOrList) : any(permOrList);
    return hasPermission(permOrList);
  };

  const can = {
    // permission helpers
    perm: (p: string) => hasPermission(p),
    anyPerm: (list: string[]) => any(list),
    allPerm: (list: string[]) => all(list),
    allow,

    // role helpers
    role: (r: string) => hasRole(r),
    anyRole: (list: string[]) => hasAnyRole(list),

    // data
    perms,
    roles,
    adminPerms,
  };

  return { user, loading, can };
}
